import { createFileRoute } from '@tanstack/react-router';

import { filterState } from '@/_containers';
import { Loading } from '@/_pages/dashboard/loading';

export const Route = createFileRoute('/_private/dashboard/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  // loader: (opts) => opts.context.queryClient.ensureQueryData(getCustomSettingsQuery()),
  pendingComponent: Loading,
});
